var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('av-media',{staticClass:"waveform",attrs:{"media":_vm.stream,"frequ-lnum":_vm.lineNum,"type":"frequ","canv-width":_vm.waveWidth,"canv-height":_vm.waveHeight,"line-color":"#1287cd","line-width":_vm.lineWidth,"frequ-line-cap":_vm.lineCap}})}
var staticRenderFns = []

export { render, staticRenderFns }